/**
 * Initialize shared analytics modules on DOM ready.
 * Runs initAnalyticsQueue, initGoogleAnalytics, initVitallyAnalytics in order,
 * then registerClickListeners for data-ga-event and data-ganame.
 */
import { onDomReady } from '../../../assets/javascripts/utils';
import { initAnalyticsQueue } from './analytics-queue';
import { initGoogleAnalytics, registerClickListeners } from './google-analytics';
import { initVitallyAnalytics } from './vitally-analytics';

onDomReady(() => {
  if (window?.Slzr) {
    initAnalyticsQueue(window.Slzr);
    initGoogleAnalytics(window.Slzr);
    initVitallyAnalytics(window.Slzr);
    registerClickListeners();
  }
});
